module.exports = __webpack_public_path__ + "static/img/MANCHESTER-MAPLE.c44fb55.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/MANCHESTER-MAPLE.png
// module id = qG6k
// module chunks = 0